import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Home365LoaderModule} from "../loader/home365-loader.module";
import { NoMediaPermissionsComponent } from './no-media-permissions/no-media-permissions.component';


@NgModule({
  declarations: [
    NoMediaPermissionsComponent
  ],
  imports: [
    CommonModule,
    Home365LoaderModule
  ],
  exports: [
    NoMediaPermissionsComponent
  ]
})
export class RecordMediaModule {
}
